<template>
  <div class="report">
    <div class="row">
      <div class="col-12">
        <div class="mt-2">
          <router-link class="btn btn-secondary mr-2" to="/dashboard">Back</router-link>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="mt-4">
          <label>Date:</label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        <datepicker :format="'yyyy-MM-dd'" :inputClass="'form-control'" v-model="date"></datepicker>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <div class="form-group">
          <label class="radio-inline mb-0">
            <input type="radio" name="interval" v-model="interval" :value="30">&nbsp;&nbsp;Time interval 30
          </label>
          <label class="radio-inline mb-0 ml-3">
            <input type="radio" name="interval" v-model="interval" :value="60">&nbsp;&nbsp;Time interval 60
          </label>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-4">
        <button class="btn btn-primary" @click.prevent="getReport">Submit</button>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12 table-responsive">
        <table class="table table-striped table-report">
          <thead>
            <tr>
              <th class="text-center"></th>
              <th class="text-center" colspan="5">Back Log</th>
              <th class="text-center" colspan="3">End of Period Acting</th>
              <th class="text-center" colspan="4"></th>
            </tr>
            <tr>
              <th class="text-center">Time</th>
              <th class="text-center">Open Balance</th>
              <th class="text-center">New Contact</th>
              <th class="text-center">Total to Process</th>
              <th class="text-center">Answer</th>
              <th class="text-center">End Period Balance</th>
              <th class="text-center">Not Late (&lt; 1 min)</th>
              <th class="text-center">Late (1 - 3 min)</th>
              <th class="text-center">Super Late (&gt; 3 min)</th>
              <th class="text-center">ASA</th>
              <th class="text-center">(s)</th>
              <th class="text-center">ASR</th>
              <th class="text-center">(s)</th>
              <th class="text-center">AHT</th>
              <th class="text-center">(s)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in report" :key="index">
              <td class="text-center">{{ item.label }}</td>
              <td class="text-center">{{ item.balance | formatNumber }}</td>
              <td class="text-center">{{ item.new | formatNumber }}</td>
              <td class="text-center">{{ item.process | formatNumber }}</td>
              <td class="text-center">{{ item.answer | formatNumber }}</td>
              <td class="text-center">{{ item.end_balance | formatNumber }}</td>
              <td class="text-center">{{ item.not_late | formatNumber }}</td>
              <td class="text-center">{{ item.late | formatNumber }}</td>
              <td class="text-center">{{ item.super_late | formatNumber }}</td>
              <td class="text-center">
                <template v-if="getAverageASA(item)">
                  {{ getAverageASA(item) }}
                </template>
                <template v-else>
                  -
                </template>
              </td>
              <td class="text-center">
                <template v-if="getAverageASA(item)">
                  {{ getAverageASA(item, 's') | formatNumber }}
                </template>
                <template v-else>
                  -
                </template>
              </td>
              <td class="text-center">
                <template v-if="getAverageASR(item)">
                  {{ getAverageASR(item) }}
                </template>
                <template v-else>
                  -
                </template>
              </td>
              <td class="text-center">
                <template v-if="getAverageASR(item)">
                  {{ getAverageASR(item, 's') | formatNumber }}
                </template>
                <template v-else>
                  -
                </template>
              </td>
              <td class="text-center">
               <template v-if="getAverageAHT(item)">
                  {{ getAverageAHT(item) }}
                </template>
                <template v-else>
                  -
                </template>
              </td>
              <td class="text-center">
               <template v-if="getAverageAHT(item)">
                  {{ getAverageAHT(item, 's') | formatNumber }}
                </template>
                <template v-else>
                  -
                </template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      report: [],
      date: Date(),
      interval: 30
    }
  },
  components: {
    Datepicker
  },
  computed: {
    ...mapState('admin', ['admin'])
  },
  filters: {
    formatNumber: value => {
      if (value) {
        if (Math.abs(Number(value)) < 0.01) {
          return '0'
        }
        return Number(value).toFixed(0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return '0'
    }
  },
  methods: {
    getAverageASA (item, format = '') {
      if (!item.asa_count || !item.asa_sum) {
        return null
      }
      let s = item.asa_sum / item.asa_count
      if (format === 's') {
        return Math.floor(s)
      }
      return this.formatDuration(s)
    },
    getAverageASR (item, format = '') {
      if (!item.asr_count || !item.asr_sum) {
        return null
      }
      let s = item.asr_sum / item.asr_count
      if (format === 's') {
        return Math.floor(s)
      }
      return this.formatDuration(s)
    },
    getAverageAHT (item, format = '') {
      if (!item.aht_count || !item.aht_sum) {
        return null
      }
      let s = item.aht_sum / item.aht_count
      if (format === 's') {
        return Math.floor(s)
      }
      return this.formatDuration(s)
    },
    formatDuration (s) {
      let h = 0
      let m = 0
      if (s > 60) {
        m = Math.floor(s / 60)
        s = Math.floor(s - (m * 60))
      }
      if (m > 60) {
        h = Math.floor(m / 60)
        m = m - (h * 60)
      }
      return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`
    },
    async getReport () {
      let queryParams = { date: moment(this.date).format('YYYY-MM-DD'), interval: this.interval }
      if (this.$route.query.customer_type) {
        queryParams.customer_type = this.$route.query.customer_type
      }
      const res = await axios.get('reports/hourly', { params: queryParams })
      if (res.status === 200) {
        this.report = res.data.report ? res.data.report : []
      } else {
        this.report = []
      }
    }
  },
  mounted () {
    this.getReport()
  }
}
</script>

<style lang="scss" scoped>
.report {
  padding: 1rem;
}
.table-report {
  font-size: 80%;
}
</style>
